import { AffiliateProps } from 'models'
import { getTrackingConstants, minifyObject } from 'utils'
import packageJSON from '../../package.json'

/**
 * openAffiliateLink event handler
 *  - Build the affiliate link
 *  - Redirect to the operator website
 **/
export const openAffiliateLink = ({
    cid = 'bs-rp-0',
    cUid,
    operator = 'GENYBET',
    meetingNumber,
    raceNumber,
    raceDate,
    tBet = []
}: Pick<
    AffiliateProps,
    | 'cid'
    | 'cUid'
    | 'operator'
    | 'meetingNumber'
    | 'raceNumber'
    | 'raceDate'
    | 'tBet'
>): void => {
    const host = process.env.REACT_APP_AFFILIATION_ENGINE_LINK
    const { device, sid, country, osName, mediaId } = getTrackingConstants()

    if (!mediaId || !sid || !country || !cUid) return
    const parameters: Omit<AffiliateProps, 'tBet'> = {
        mediaId,
        cid,
        cUid,
        device,
        sid,
        country,
        operator,
        meetingNumber,
        raceNumber,
        raceDate,
        appVersion: packageJSON.version,
        osVersion: osName
    }
    const betString = minifyObject(tBet)
    const parametersString = Object.entries(parameters).reduce(
        (acc, entry) =>
            `${acc}${acc.length ? '&' : '?'}${entry[0]}=${entry[1]}`,
        ''
    )
    const link = `${host}/${parametersString}&tb=${betString}`

    console.debug(
        '[BETSLIP] openAffiliateLink() - %d characters - %o %o',
        link.length,
        `${parametersString}&tb=${betString}`,
        {
            host,
            params: { ...parameters, tBet }
        }
    )
    window.open(link)
}

export const REGISTER_AFFILIATE_LINK =
    'https://app.adjust.com/1qrg4ru1?adgroup=ACQ_H_PARISTURFLIVE_MULTIDEVICE_RG_BETSLIP_BETSLIP_PCC&creative=ACQ_H_PMU+_BETSLIP&fallback=https%3A%2F%2Finscription.pmu.fr%2F%3FtypeCompte%3D85%26clientApi%3D62%26utm_medium%3DAFF%26utm_campaign%3D85_AFF_FILROUGE%26utm_source%3DPARISTURF%26utm_content%3DACQ_H_PARISTURF_MULTIDEVICE_RG_MULTI_MULTI%26utm_term%3DACQ_H_PMU+_MULTI&redirect_macos=https%3A%2F%2Finscription.pmu.fr%2F%3FtypeCompte%3D85%26clientApi%3D62%26utm_medium%3DAFF%26utm_campaign%3D85_AFF_FILROUGE%26utm_source%3DPARISTURF%26utm_content%3DACQ_H_PARISTURF_MULTIDEVICE_RG_MULTI_MULTI%26utm_term%3DACQ_H_PMU+_MULTI'
